/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    beforeEnter: () => {
      window.location.href = `/apps/partner/members${window.location.search}`;
    },
    component: () =>
      import(

        /* webpackChunkName: "partner" */
        '@/modules/members/scenes/members.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.MEMBERS.PARTNER_MEMBERS,
    path: 'partner/members'
  }
] as RouteConfig[];
